import { Receipt as ReceiptIcon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import { Button } from "@/components/core";

export function ReceiptButton({ onClick }: any) {
  const { t } = useTranslation("common");

  return (
    <Button variant="contained" startIcon={<ReceiptIcon />} onClick={onClick}>
      {t("bankReceipt")}
    </Button>
  );
}

ReceiptButton.propTypes = {
  onClick: PropTypes.func,
};
